import { Skeleton } from '@mui/material';
import React from 'react';
import Flex from 'ui/Flex/Flex';
import { GRID_DEFAULT_HEIGHT } from '../ui/constants';

export default function LoadingBarChart(): React.ReactElement {
    return (
        <Flex flexDirection="column" alignItems="center">
            <Flex
                flexDirection="row"
                alignItems="flex-end"
                justifyContent="space-between"
                sx={{
                    padding: '0 12rem',
                    height: GRID_DEFAULT_HEIGHT,
                    width: '100%',
                }}
            >
                {[
                    '12rem',
                    '16rem',
                    '9rem',
                    '11rem',
                    '10rem',
                    '15rem',
                    '17rem',
                    '22rem',
                    '13rem',
                ].map((height) => (
                    <Skeleton
                        key={`${height}`}
                        variant="rectangular"
                        sx={{ width: '5rem', height }}
                    />
                ))}
            </Flex>
            <Skeleton
                variant="rectangular"
                sx={{ height: '0.2rem', width: '80%' }}
            />
        </Flex>
    );
}
